'use client';
import {MediaQuery} from '@constants/theme';
import MuiBox from '@new-components/atoms/MuiBox';
import {useLeadForm} from '@new-components/templates/LeadGeneration/provider';
import React, {FC} from 'react';

interface DarnaJoinButtonProps {
  buttonLabel: string;
}

const DarnaJoinButton: FC<DarnaJoinButtonProps> = (props) => {
  const {show} = useLeadForm();
  const handleJoinButtonClick = () => {
    show({
      formType: 'DARNA_FORM',
      id: 'darna_join_form',
    });
  };
  return (
    <MuiBox
      onClick={handleJoinButtonClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0px 20px',
        height: '40px',
        width: 'fit-content',
        borderRadius: '500px',
        backgroundBlendMode: 'lighten',
        background: 'rgba(235, 105, 36, 1)',
        backdropFilter: 'blur(80px)',
        fontSize: '15px',
        fontWeight: '400',
        color: '#fff',
        textDecoration: 'none',
        lineHeight: '18.75px',
        letterSpacing: '-0.4000000059604645px',
        cursor: 'pointer',
        [MediaQuery.desktop]: {
          fontSize: '15px',
        },
      }}>
      {props.buttonLabel}
    </MuiBox>
  );
};

export default DarnaJoinButton;
